var _filter, _filter2, _filter3, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 2027,
    viewBox: "0 0 2560 2027",
    width: 2560,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 2389.92,
    width: 5378.37,
    x: -1489.66,
    y: -328.023
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2278_68",
    stdDeviation: 300
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 2838.78,
    width: 3698.19,
    x: -1707.56,
    y: -1082.75
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2278_68",
    stdDeviation: 500
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 3498.78,
    width: 4420.68,
    x: 150.062,
    y: -901.055
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2278_68",
    stdDeviation: 600
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    height: 2027,
    maskUnits: "userSpaceOnUse",
    width: 2560,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h2560v2027h-2560z",
    fill: "#d9d9d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1369.94 274.521c1149.91 30.11 2005.81 319.754 1911.69 646.938-94.11 327.181-1102.6 568.011-2252.52 537.901-1149.918-30.11-2005.814-319.76-1911.697-646.942 94.116-327.183 1102.605-568.008 2252.527-537.897z",
    fill: "#bd3aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1369.94 274.521c1149.91 30.11 2005.81 319.754 1911.69 646.938-94.11 327.181-1102.6 568.011-2252.52 537.901-1149.918-30.11-2005.814-319.76-1911.697-646.942 94.116-327.183 1102.605-568.008 2252.527-537.897z",
    fill: "#d278ff",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m520.394-37.2984c419.558 104.7676 590.056 357.1154 380.818 563.6344s-718.978 289.005-1138.536 184.238c-419.559-104.768-590.057-357.116-380.819-563.635 209.238-206.5191 718.978-289.005 1138.537-184.2374z",
    fill: "#ff009c"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3330.53 1261.03c-155.35 200.28-715.62 177.87-1251.41-50.06-535.78-227.923-844.19-575.049-688.84-775.327s715.62-177.866 1251.4 50.059c535.79 227.924 844.2 575.048 688.85 775.328z",
    fill: "#c7a3ff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundContact);
export default __webpack_public_path__ + "static/media/background-contact.03295998a6b6e2b250fca7a778f3749d.svg";
export { ForwardRef as ReactComponent };